import { render, staticRenderFns } from "./RodadaCompra.vue?vue&type=template&id=2d01584c&scoped=true"
import script from "./RodadaCompra.vue?vue&type=script&setup=true&lang=js"
export * from "./RodadaCompra.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RodadaCompra.vue?vue&type=style&index=0&id=2d01584c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d01584c",
  null
  
)

export default component.exports